var PingPongTimeline = /** @class */ (function () {
    function PingPongTimeline() {
        this.start = 0;
        this.duration = 100;
        this.effect = 20;
    }
    Object.defineProperty(PingPongTimeline.prototype, "end", {
        get: function () {
            return this.start + this.duration;
        },
        enumerable: false,
        configurable: true
    });
    PingPongTimeline.prototype.value = function (time) {
        if (time <= this.start) {
            return 0;
        }
        if (time >= this.end) {
            return 0;
        }
        // intro
        if (time > this.start && time < this.start + this.effect) {
            return (time - this.start) / this.effect;
        }
        // outro
        else if (time < this.end && time > this.end - this.effect) {
            return (this.end - time) / this.effect;
        }
        // inbetween
        return 1;
    };
    return PingPongTimeline;
}());
export { PingPongTimeline };
